module.exports = __webpack_public_path__ + "static/media/bg.ec0e7ce2.jpg";